import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {
  terminateURL: string;
  ClientUrl: String;
  LogId: String;
  Mode: number;


  api_base_url = environment.baseUrl;


  // api_base_url = 'https://adminapibetaangular.opinionest.com';

  constructor(private _http: HttpClient) { }

  GetUserQuestion(id, mode): Observable<HttpResponse<any>> {
    const url = `${this.api_base_url}Screener/NextScreenQuestion?LogId=${id}&Mode=${mode}`;

    return this._http.get<any>(url, { observe: 'response' })
  }

  SaveUserAnswer(data): Observable<HttpResponse<any>> {
    return this._http.post(`${this.api_base_url}Screener/SaveUserScreenResponse`, data, { observe: 'response' });
  }

    throttleCheck(data:any): Observable<HttpResponse<any>>{
    return this._http.post(`${this.api_base_url}RD/ClickThrottelCheck`, data, { observe: 'response' });
  }
}
